export default __webpack_public_path__ + "static/media/jackpot.9f684b7e.jpg";